module.exports = __webpack_public_path__ + "static/media/yu-assist.8c081314.jpg";